export default __webpack_public_path__ + "static/media/king.e33d6f24.png";